module.exports = __webpack_public_path__ + "sao-tome-and-prince.svg?c30558125620a153ee43193a544a8cf5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/sao-tome-and-prince.svg
// module id = 283
// module chunks = 10